import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterListingPage_template} from "./filterListingPage_template";
import {pinnedListingPages_template} from "./pinnedListingPages_template";
import {HubPagePinnedHubPage} from "../../utils/types/listing_page";
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import { imageWidget_template } from "./imageWidget_template";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import Title from "amcharts/Title";

declare var ko: any;

export class configSidebar_template extends vnTemplate{

    protected pinnedListingPages: pinnedListingPages_template;
    public imagePicker: imagePicker_template;
    protected imagePickerHelper: imagePickerHelper;
    public imageWidget: imageWidget_template;

    protected getTemplateHtml(): string{
        let myThis = this;
        return `
            <div class="w-form pinned-articles">
                <div class="form-header">
                    <input type="hidden">

                    <h3 class="form-title ">General</h3>

                </div>

                <div class="form-body">
                    <table class="list-action">
                        <thead>
                            <tr>
                                <th></th>
                                <th><span>home page</span></th>
                                <th><span>article page</span></th>
                                <th><span>hub page</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td class="align-center">
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('home_page', true)}" class="btn-form" type="button">Select all</button>
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('home_page', false)}" class="btn-form" type="button">Deselect all</button>
                                </td>
                                <td class="align-center">
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('article_page', true)}" class="btn-form" type="button">Select all</button>
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('article_page', false)}" class="btn-form" type="button">Deselect all</button>
                                </td>
                                <td class="align-center">
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('listing_page', true)}" class="btn-form" type="button">Select all</button>
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('listing_page', false)}" class="btn-form" type="button">Deselect all</button>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="form-label">Popular Section</span></td>
                                <td>
                                    <div class="form-group">
                                        <input type="checkbox" id="show-popular-section-on-home-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isPopularSectionEnabledOnHomePage">
                                        <label for="show-popular-section-on-home-page" class="form-label icon i-check">Enabled</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <input type="checkbox" id="show-popular-section-on-article-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isPopularSectionEnabledOnArticlePage">
                                        <label for="show-popular-section-on-article-page" class="form-label icon i-check">Enabled</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <input type="checkbox" id="show-popular-section-on-listing-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isPopularSectionEnabledOnListingPage">
                                        <label for="show-popular-section-on-listing-page" class="form-label icon i-check">Enabled</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="form-label">Trending Now Section</span></td>
                                <td>
                                    <div class="form-group">
                                        <input type="checkbox" id="show-trending-section-on-home-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isTrendingNowSectionEnabledOnHomePage">
                                        <label for="show-trending-section-on-home-page" class="form-label icon i-check">Enabled</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group" style="gap: 30px;">
                                        <input type="checkbox" id="show-trending-section-on-article-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isTrendingNowSectionEnabledOnArticlePage">
                                        <label for="show-trending-section-on-article-page" class="form-label icon i-check">Enabled</label>
                                        <input type="checkbox" id="with-tag-interaction-on-article-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isTrendingNowWithTagInteractionOnArticlePage">
                                        <label for="with-tag-interaction-on-article-page" class="form-label icon i-check">With Tag Interaction</label>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <input type="checkbox" id="show-trending-section-on-listing-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isTrendingNowSectionEnabledOnListingPage">
                                        <label for="show-trending-section-on-listing-page" class="form-label icon i-check">Enabled</label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="form-footer">
                      <button data-bind="disable: !permissions()['sidebar_trending'].update, event: { click: onClickCancelGeneralConfig }" title="There will be no changes made" class="btn " type="button">Cancel</button>
                      <button data-bind="disable: !permissions()['sidebar_trending'].update, event: { click: onClickSaveGeneralConfig }" class="btn highlight" type="button">Save</button>
                   </div>
                </div>
            </div>
            <div class="ww-form side-by-side">
                <div class="w-form  pinned-articles">
                    <div class="form-header">
                        <input type="hidden">

                        <h3 class="form-title icon i-poll">Pinned Poll</h3>

                    </div>

                    <div class="form-body">
                        <table class="list-action">
                            <thead>
                                <tr>
                                    <th><span>home page</span></th>
                                    <th><span>article page</span></th>
                                    <th><span>hub page</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="form-group">
                                            <input type="checkbox" id="show-poll-section-on-home-page" data-bind="checked: isPinnedPollEnabledOnHomePage">
                                            <label for="show-poll-section-on-home-page" class="form-label icon i-check">Enable</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input type="checkbox" id="show-poll-section-on-article-page" data-bind="checked: isPinnedPollEnabledOnArticlePage">
                                            <label for="show-poll-section-on-article-page" class="form-label icon i-check">Enable</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input type="checkbox" id="show-poll-section-on-listing" data-bind="checked: isPinnedPollEnabledOnListingPage">
                                            <label for="show-poll-section-on-listing" class="form-label icon i-check">Enable</label>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                       <!-- ko ifnot: idPoll() == null -->
                       <div class="form-group-flex">

                            <div class="form-group-flex-header">
                                <strong class="form-position">Position 1</strong>
                                <button data-bind="event: { click: onClickDeletePinnedPoll }" title="Clear Position" type="button" class="btn border only-icon icon i-edit"></button>
                            </div>

                            <div class="form-group">

                               <span class="form-text-date" data-bind="text: pollDateCreated"></span>
                               <strong class="form-text-title" data-bind="text: pollName"></strong>
                               <dl class="double-list">
                                    <dt><span>Poll ID</span></dt>
                                    <dd><span data-bind="text: idPoll"></span></dd>
                               </dl>
                           </div>
                           <div class="form-group">

                                <div class="row">
                                    <label for="" class="form-label icon i-time">Hours Pinned</label>
                                    <input data-bind="value: pollHoursPinned" class="input-text amount"  type="number" min="0" step="1" id="" name="">
                                </div>

                                <div class="row">
                                     <label for="" class="form-label icon i-hourglass">Time Left</label>
                                      <span class="time" data-bind="text: pollTimeleft"></span>
                                </div>

                           </div>
                       </div>
                       <!-- /ko -->

                       <!-- ko if: idPoll() == null -->
                       <div class="form-group-flex">

                            <div class="form-group-flex-header">
                            </div>
                            <button title="Clear Position" type="button" class="btn border only-icon icon i-edit is-hidden"></button>

                            <div class="form-group cleared">
                                 <div class="w-spec-search icon i-auto-complete i-poll-a">
                                    <input class="input-text" placeholder="Poll Name" list="polls" type="text"
                                        data-bind="
                                         event:{
                                             keyup: () => onChangePoll($data.pollName()),
                                             blur: onSelectedPoll
                                         },
                                         textInput: pollName, valueUpdate: 'afterkeydown'"
                                        />
                                    <datalist id="polls" data-bind="foreach: pinnedPoll_options">
                                        <option data-bind="value: name">
                                    </datalist>
                                </div>
                            </div>
                       </div>

                       <!-- /ko -->
                    </div>
                    <div class="form-footer">
                        <button data-bind="event: { click: onClickCancelPinnedPoll }" title="There will be no changes made" class="btn " type="button">Cancel</button>
                        <button data-bind="event: { click: onClickSavePinnedPoll }" class="btn highlight" type="button">Save Pinned Poll</button>
                    </div>
                </div>
                <div class="w-form">
                    <div class="form-header">
                        <h3 class="form-title icon i-listing-page">Pinned Hub Pages</h3>
                    </div>
                    <div class="form-body pinned-articles">
                        <table class="list-action">
                            <thead>
                                <tr>
                                    <th><span>home page</span></th>
                                    <th><span>article page</span></th>
                                    <th><span>Hub page</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="form-group">
                                            <input type="checkbox" id="show-lp-section-on-home-page" data-bind="checked: isPinnedListingPageEnabledOnHomePage">
                                            <label for="show-lp-section-on-home-page" class="form-label icon i-check">Enable</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input type="checkbox" id="show-lp-section-on-article-page" data-bind="checked: isPinnedListingPageEnabledOnArticlePage">
                                            <label for="show-lp-section-on-article-page" class="form-label icon i-check">Enable</label>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input type="checkbox" id="show-lp-section-on-listing" data-bind="checked: isPinnedListingPageEnabledOnListingPage">
                                            <label for="show-lp-section-on-listing" class="form-label icon i-check">Enable</label>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="form-group">
                            <div class="form-check-inline width-auto">
                                <input type="radio" id="emaki-hub-pages" name="radio-group" value="emaki-hub-pages" data-bind="checked: pinnedHubPageType">
                                <label  for="emaki-hub-pages">Emaki Hub Pages</label>
                            </div>
                            <div class="form-check-inline width-auto">
                                <input type="radio" id="custom-pages" name="radio-group" value="custom-pages" data-bind="checked: pinnedHubPageType">
                                <label for="custom-pages">Custom Pages</label>
                            </div>
                        </div>
                        <div class="form-group" data-bind="visible: pinnedHubPageType() == 'emaki-hub-pages'">
                            <hr>
                            `+ this.pinnedListingPages.getHtmlBuild()+`
                        </div>
                        <div data-bind="visible: pinnedHubPageType() == 'custom-pages'">
                            <div class="form-group">
                                <label class="form-label">Number of Position Lists</label>
                                <select class="input-select" data-bind="value: numberOfPositionLists">
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label">List Title</label>
                                <input type="text" class="input-text" data-bind="value: customPageTitle1"/>
                            </div>
                            <div class="form-group">
                                <label class="form-label">More Linkout Title</label>
                                <input type="text" class="input-text" data-bind="value: customPageMoreLinkoutTitle1"/>
                            </div>              
                            <div class="form-group">
                                <label class="form-label">More Linkout Url</label>
                                <input type="text" class="input-text" data-bind="value: customPageMoreLinkoutUrl1"/>
                            </div>
                            <div data-bind="visible: numberOfPositionLists() == 2">
                                <div class="form-group">
                                    <label class="form-label">List Title 2</label>
                                    <input type="text" class="input-text" data-bind="value: customPageTitle2"/>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">More Linkout Title 2</label>
                                    <input type="text" class="input-text" data-bind="value: customPageMoreLinkoutTitle2"/>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">More Linkout Url 2</label>
                                    <input type="text" class="input-text" data-bind="value: customPageMoreLinkoutUrl2"/>
                                </div>
                            </div>
                            <div class="form-group">
                                <button data-bind="event: { click: onClickTogglePinnedCustomPageSection(true) }" class="btn highlight" type="button">Add Pinned Custom Page</button>
                            </div>
                            <div class="form-group " data-bind="foreach: pinnedCustomPageItems, childrenComplete : handleDragAndDrop($element, pinnedCustomPageItems ,'.entry')">
                                <div class="form-body w-pinned">
                                    <div class="pinned-form listingPage-pinned entry">
                                        <div class="pinned-drag icon i-drag">
                                            <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                        </div>
                                        <div class="w-btn">
                                            <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditPinnedCustomPageItem }"><span class="hidden-text">Edit</span></button>
                                            <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedCustomPageItem }"><span class="hidden-text">Delete</span></button>
                                        </div>
                                        <div class="w-title">
                                            <span class="pinned-title">Card Title :<span data-bind="text: cardTitle"></span></span>
                                            <span class="pinned-title">Card Linkout :<span data-bind="text: cardLinkoutUrl"></span></span>
                                            <!-- ko if: cardImage && cardImage.url -->
                                            <div class="pinned-title"> Card Image:
                                                <img data-bind="attr: { src: cardImage.url + '?w=50&h=50', alt: cardImage.altText || 'Card image' }" style="width: 50px; height: 50px; object-fit: cover; margin-left: 5px;" />
                                            </div>
                                            <!-- /ko -->
                                            <span class="pinned-title">Card Description :<span data-bind="html: cardDescription"></span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                   </div>

                   <div class="form-footer">
                      <button data-bind="event: { click: onClickCancelPinnedPageConfig }" title="There will be no changes made" class="btn " type="button">Cancel</button>
                      <button data-bind="event: { click: onClickSavePinnedPageConfig }" class="btn highlight" type="button">Save</button>
                   </div>
                </div>
            </div>
            <div data-bind="css: { 'is-visible': isAddPinnedCustomPageVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form w-form-large lightbox-form">
                        <div class="pinned-form">
                            <div class="form-header">
                                <h3 class="form-title">Add Pinned Custom Card</h3>
                                <button class="close-button icon i-close-2" data-bind="event: { click: onClickTogglePinnedCustomPageSection(false)}"></button>
                            </div> 
                            <div class="w-form-body">

                                <div class="form-body">
                                    <div class="form-group">
                                        <label class="form-label">Card Title</label>
                                        <input type="text" class="input-text" data-bind="value: customCardTitle"/>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Card Linkout</label>
                                        <input type="text" class="input-text" data-bind="value: customCardLinkoutUrl"/>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">Image</label>
                                        <div style="width: 200px; height: 200px; overflow: hidden;">
                                            ${ this.imageWidget.getHtmlBuild() }
                                        </div>
                                    </div>
                                </div>
                                <div class="form-body">
                                    <div class="form-group">
                                        <label class="form-label">Description</label>
                                        <textarea id="customCardDescription" class="input-textarea"></textarea>
                                    </div>
                                </div>
                            </div>

                            
                            <div class="form-footer">
                                <button class="btn secondary" type="button" data-bind="event:{click: onClickAddPinnedCustomPageItem }, text: 'Add'">Add to List</button>
                                <button type="button" data-bind="event: { click: onClickTogglePinnedCustomPageSection(false)}" class="btn ">Cancel</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            ${this.imagePicker.getHtmlBuild()}
        `;

    }

    protected initPartial(): void {

        this.pinnedListingPages = new pinnedListingPages_template('pinnedListingPages', this.getTemplateViewModel(), this.caller);
        this.pinnedListingPages.setMaximum(2);

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(this.imagePicker, this.caller.viewModel, this.caller.getVnAppZone(), this.caller);
        this.imageWidget = new imageWidget_template('custom_page_image', this.getTemplateViewModel(), this);
        this.imageWidget.setMode('single-select');
        this.imageWidget.setCaller(this.imagePickerHelper);
    }

    protected getTemplateName(): string{
        return "configSidebar-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["div", "config-homepage"];
    }

    protected buildViewModel(): any{

        let self = this;
        return  {
            idPoll: ko.observable(null),
            poll: ko.observable(null),
            pollTimeleft: ko.observable(null),
            pollHoursPinned: ko.observable(null),
            pollDateCreated: ko.observable(null),
            pollName: ko.observable(""),
            pinnedPoll_options: ko.observableArray([]),
            isPopularSectionEnabledOnHomePage:ko.observable(false),
            isPopularSectionEnabledOnArticlePage:ko.observable(false),
            isPopularSectionEnabledOnListingPage:ko.observable(false),
            isTrendingNowSectionEnabledOnHomePage: ko.observable(false),
            isTrendingNowSectionEnabledOnArticlePage: ko.observable(false),
            isTrendingNowWithTagInteractionOnArticlePage: ko.observable(false),
            isTrendingNowSectionEnabledOnListingPage: ko.observable(false),
            isPinnedPollEnabledOnHomePage: ko.observable(false),
            isPinnedPollEnabledOnArticlePage: ko.observable(false),
            isPinnedPollEnabledOnListingPage: ko.observable(false),
            isPinnedListingPageEnabledOnHomePage: ko.observable(false),
            isPinnedListingPageEnabledOnArticlePage: ko.observable(false),
            isPinnedListingPageEnabledOnListingPage: ko.observable(false),
            pinnedHubPageType: ko.observable("emaki-hub-pages"),
            numberOfPositionLists: ko.observable(1),
            isAddPinnedCustomPageVisible: ko.observable(false),
            customPageTitle1: ko.observable(''),
            customPageTitle2: ko.observable(''),
            customPageMoreLinkoutTitle1: ko.observable(''),
            customPageMoreLinkoutUrl1: ko.observable(''),
            customPageMoreLinkoutTitle2: ko.observable(''),
            customPageMoreLinkoutUrl2: ko.observable(''),
            customCardTitle: ko.observable(''),
            customCardLinkoutUrl: ko.observable(''),
            pinnedCustomPageItems: ko.observableArray([]),
            cardEdited: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions(['sidebar_trending'])),
            onClickCancelPinnedPoll: function (data, event) {
                self.onClickCancelPinnedPoll();
            },
            onClickCancelGeneralConfig: function(data,event){
                 self.onClickCancelGeneralConfig();
            },
            onClickDeletePinnedPoll: function (data, event) {
                self.onClickDeletePinnedPoll();
            },
            onClickSavePinnedPoll: function (data, event) {
                self.onClickSavePinnedPoll();
            },
            onClickSaveGeneralConfig: function (data,event){
                 self.onClickSaveGeneralConfig();
            },
            onChangePoll: function (data) {
                self.onChangePoll(data);
            },
            onSelectedPoll: function () {
                self.onSelectedPoll();
            },
            onClickCancelPinnedPageConfig: (data, event) => {
                self.onClickCancelPinnedPageConfig();
            },
            onClickSavePinnedPageConfig: (data, event) => {
                self.onClickSavePinnedPageConfig();
            },
            toggleSelectAll:  (col, checked) => {
                 self.toggleSelectAll(col, checked);
            },
            onClickTogglePinnedCustomPageSection: (data, event) => {
                self.onClickTogglePinnedCustomPageSection(data);
            },
            onClickAddPinnedCustomPageItem: () => {
                self.onClickAddPinnedCustomPageItem();
            },
            onClickDeletePinnedCustomPageItem: (data, event) => {
                self.onClickDeletePinnedCustomPageItem(data);
            },
            onClickEditPinnedCustomPageItem: (data, event) => {
                self.onClickEditPinnedCustomPageItem(data);
            },
            handleDragAndDrop: function(element, currentObservableArray ,childrenSelector){
                self.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
            },
        };
    }

    protected toggleSelectAll(col, checked) {

        switch (col) {
            case 'home_page':
                this.getTemplateViewModel().isPopularSectionEnabledOnHomePage(checked);
                this.getTemplateViewModel().isTrendingNowSectionEnabledOnHomePage(checked);
                break;
            case 'article_page':
                this.getTemplateViewModel().isPopularSectionEnabledOnArticlePage(checked);
                this.getTemplateViewModel().isTrendingNowSectionEnabledOnArticlePage(checked);
                this.getTemplateViewModel().isTrendingNowWithTagInteractionOnArticlePage(checked);
                break;

            case 'listing_page':
                this.getTemplateViewModel().isPopularSectionEnabledOnListingPage(checked);
                this.getTemplateViewModel().isTrendingNowSectionEnabledOnListingPage(checked);
                break;

        }
    }

    public setPinnedPoll(pinnedPoll){

        if(pinnedPoll.poll != null){
            this.getTemplateViewModel().idPoll(pinnedPoll.poll.id);
            this.getTemplateViewModel().pollName(pinnedPoll.poll.name);
            this.getTemplateViewModel().pollTimeleft(pinnedPoll.timeLeft);
        }

    }

    public isPopularSectionEnabled(isPopularSectionEnabledOnHomePage) {
        this.getTemplateViewModel().isPopularSectionEnabledOnHomePage(isPopularSectionEnabledOnHomePage);
    }

    public isPopularSectionEnabledOnHomePage(isPopularSectionEnabledOnHomePage) {
        this.getTemplateViewModel().isPopularSectionEnabledOnHomePage(isPopularSectionEnabledOnHomePage);
    }

    public isPopularSectionEnabledOnArticlePage(isPopularSectionEnabledOnArticlePage) {
        this.getTemplateViewModel().isPopularSectionEnabledOnArticlePage(isPopularSectionEnabledOnArticlePage);
    }

    public isPopularSectionEnabledOnListingPage(isPopularSectionEnabledOnListingPage) {
        this.getTemplateViewModel().isPopularSectionEnabledOnListingPage(isPopularSectionEnabledOnListingPage);
    }

    public isTrendingNowSectionEnabledOnHomePage(isTrendingNowSectionEnabledOnHomePage) {
        this.getTemplateViewModel().isTrendingNowSectionEnabledOnHomePage(isTrendingNowSectionEnabledOnHomePage);
    }

    public isTrendingNowSectionEnabledOnArticlePage(isTrendingNowSectionEnabledOnArticlePage) {
        this.getTemplateViewModel().isTrendingNowSectionEnabledOnArticlePage(isTrendingNowSectionEnabledOnArticlePage);
    }

    public isTrendingNowWithTagInteractionOnArticlePage(isTrendingNowWithTagInteractionOnArticlePage) {
        this.getTemplateViewModel().isTrendingNowWithTagInteractionOnArticlePage(isTrendingNowWithTagInteractionOnArticlePage);
    }

    public isTrendingNowSectionEnabledOnListingPage(isTrendingNowSectionEnabledOnListingPage) {
        this.getTemplateViewModel().isTrendingNowSectionEnabledOnListingPage(isTrendingNowSectionEnabledOnListingPage);
    }

    public isPinnedPollEnabledOnHomePage(isPinnedPollEnabledOnHomePage) {
        this.getTemplateViewModel().isPinnedPollEnabledOnHomePage(isPinnedPollEnabledOnHomePage);
    }

    public isPinnedPollEnabledOnArticlePage(isPinnedPollEnabledOnArticlePage) {
        this.getTemplateViewModel().isPinnedPollEnabledOnArticlePage(isPinnedPollEnabledOnArticlePage);
    }

    public isPinnedPollEnabledOnListingPage(isPinnedPollEnabledOnListingPage) {
        this.getTemplateViewModel().isPinnedPollEnabledOnListingPage(isPinnedPollEnabledOnListingPage);
    }

    public isPinnedListingPageEnabledOnHomePage(isPinnedListingPageEnabledOnHomePage) {
        this.getTemplateViewModel().isPinnedListingPageEnabledOnHomePage(isPinnedListingPageEnabledOnHomePage);
    }

    public isPinnedListingPageEnabledOnArticlePage(isPinnedListingPageEnabledOnArticlePage) {
        this.getTemplateViewModel().isPinnedListingPageEnabledOnArticlePage(isPinnedListingPageEnabledOnArticlePage);
    }

    public isPinnedListingPageEnabledOnListingPage(isPinnedListingPageEnabledOnListingPage) {
        this.getTemplateViewModel().isPinnedListingPageEnabledOnListingPage(isPinnedListingPageEnabledOnListingPage);
    }

    public getPinnedPollViewModel(){

        return {
            idPoll: this.getTemplateViewModel().idPoll,
            hoursPinned: this.getTemplateViewModel().pollHoursPinned,
            isEnabledOnHomePage: this.getTemplateViewModel().isPinnedPollEnabledOnHomePage,
            isEnabledOnArticlePage: this.getTemplateViewModel().isPinnedPollEnabledOnArticlePage,
            isEnabledOnListingPage: this.getTemplateViewModel().isPinnedPollEnabledOnListingPage
        }
    }

    public getGeneralConfigViewModel(){
        return{
            isPopularSectionEnabledOnHomePage: this.getTemplateViewModel().isPopularSectionEnabledOnHomePage,
            isPopularSectionEnabledOnArticlePage: this.getTemplateViewModel().isPopularSectionEnabledOnArticlePage,
            isPopularSectionEnabledOnListingPage: this.getTemplateViewModel().isPopularSectionEnabledOnListingPage,
            isTrendingNowSectionEnabledOnHomePage: this.getTemplateViewModel().isTrendingNowSectionEnabledOnHomePage,
            isTrendingNowSectionEnabledOnArticlePage: this.getTemplateViewModel().isTrendingNowSectionEnabledOnArticlePage,
            isTrendingNowWithTagInteractionOnArticlePage: this.getTemplateViewModel().isTrendingNowWithTagInteractionOnArticlePage,
            isTrendingNowSectionEnabledOnListingPage: this.getTemplateViewModel().isTrendingNowSectionEnabledOnListingPage
        }
    }

    public getListingPagesConfigViewModel(){

        return {
            isPinnedListingPageEnabledOnHomePage: this.getTemplateViewModel().isPinnedListingPageEnabledOnHomePage(),
            isPinnedListingPageEnabledOnArticlePage : this.getTemplateViewModel().isPinnedListingPageEnabledOnArticlePage(),
            isPinnedListingPageEnabledOnListingPage: this.getTemplateViewModel().isPinnedListingPageEnabledOnListingPage(),
            pinnedHubPageType: this.getTemplateViewModel().pinnedHubPageType(),
            pinnedListingPages: this.getPinnedListingPages(),
            numberOfPositionLists: this.getTemplateViewModel().numberOfPositionLists(),
            pinnedCustomPages: this.getPinnedCustomPages()
        }
    }

    public setPinnedPollOptions(pinnedPoll_options){

        this.getTemplateViewModel().pinnedPoll_options(pinnedPoll_options);
    }

    protected onClickCancelPinnedPageConfig() {

        this.caller.cancelPinnedPageConfig();
    }

    protected onChangePoll(keyword : string){

        this.caller.searchPoll(keyword);
    }

    protected onSelectedPoll(){
        const selectedPollName = this.getTemplateViewModel().pollName();
        const selectedPoll = this.getTemplateViewModel().pinnedPoll_options().find(poll => poll.name === selectedPollName);
        if(selectedPoll){
            this.getTemplateViewModel().idPoll(selectedPoll.id);
            this.getTemplateViewModel().pollName(selectedPoll.name);
            this.getTemplateViewModel().pinnedPoll_options([]);
        }

    }

    protected onClickCancelPinnedPoll() {

        this.caller.cancelPinnedPoll();
    }

    protected onClickCancelGeneralConfig(){

    }

    protected onClickSaveGeneralConfig(){
        this.caller.saveGeneralConfig();
    }

    protected onClickDeletePinnedPoll() {

        this.getTemplateViewModel().idPoll(null);
        this.getTemplateViewModel().poll(null);
        this.getTemplateViewModel().pollExpire(null);
        this.getTemplateViewModel().pollTimeLeft(null);
    }

    protected setFilterAutocomplete(idElement, articles) {

        let index = idElement.replace('filterArticle','');
        let pinned = this.getTemplateViewModel().pinnedArticles();

        pinned[index].articleFilter.getTemplateViewModel().articles(articles);
    }

    protected onClickSavePinnedPoll() {

        this.caller.savePinnedPoll();
    }

    protected onClickSavePinnedPageConfig() {

        this.caller.savePinnedPageConfig();
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public setPinnedListingPages(listingPages){

        let data = [];
        for(let x in listingPages){

            let filter = new filterListingPage_template("filterShowMoreListingPage"+(x), this.getTemplateViewModel(), this.caller);
            filter.setShowDetails(true);
            filter.setPlaceholder('Show More Hub Page');

            let pinnedListingPage : HubPagePinnedHubPage = {

                id:                         listingPages[x].id,
                idListingPage:              listingPages[x].idListingPage,
                listingPage:                listingPages[x].listingPage,
                idShowMoreListingPage:      listingPages[x].idShowMoreListingPage,
                showMoreListingPage:        listingPages[x].showMoreListingPage,
                showMoreListingPageFilter:  filter,
                position:                   listingPages[x].position,
                dateCreated:                listingPages[x].dateCreated,
                alternateTitle:             listingPages[x].alternateTitle,
                enableEdit:                 false
            }

            if(listingPages[x].showMoreListingPage){

                let showMoreListingPage = listingPages[x].showMoreListingPage;
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPageObj(showMoreListingPage);
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPage(showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')');
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().idListingPage(listingPages[x].idShowMoreListingPage);
            }

            data.push(pinnedListingPage)
        }

        this.pinnedListingPages.setListingPages(data)
    }

    public getPinnedListingPages(){

        let pinnedListingPageIds = [];
        let listingPages = this.pinnedListingPages.getListingPages();

        for (let i = 0; i < listingPages.length; i++) {

            let item = {
                idListingPage: listingPages[i].idListingPage,
                idShowMoreListingPage: listingPages[i].showMoreListingPageFilter.getTemplateViewModel().idListingPage(),
                alternateTitle : listingPages[i].alternateTitle,
                position :  listingPages[i].position
            }

            pinnedListingPageIds.push(item)
        }

        return  pinnedListingPageIds;
    }

    public setFilterListingPagesAutoComplete(listingPages, listingPageIdElement: string): void {

        switch (listingPageIdElement) {
            case 'pinnedListingPages_filterListingPage':
                this.pinnedListingPages.listingPageFilter.setOptions(listingPages);
                break;
            case 'pinnedListingPages_filterShowMoreListingPage':
                this.pinnedListingPages.showMoreListingPageFilter.setOptions(listingPages);
                break;
            default:
                this.pinnedListingPages.filterSimpleOnAutoComplete(listingPages, listingPageIdElement)
        }
    }

    public onClickTogglePinnedCustomPageSection(show, reset = true) {

        if (show && reset) {
            let pinnedCustomPageItems = this.getTemplateViewModel().pinnedCustomPageItems();
            let numberOfPositionLists = this.getTemplateViewModel().numberOfPositionLists();
            if(pinnedCustomPageItems.length == (numberOfPositionLists*3)){
                this.caller.triggerNotification('Maximum custom page number reached. Please delete one to add new! ');
                return;
            }
        }

        if (reset) {
            this.getTemplateViewModel().cardEdited(null);
            this.getTemplateViewModel().customCardTitle('');
            this.getTemplateViewModel().customCardLinkoutUrl('');
            this.imageWidget.clearImage();
            if (this.caller.textAreaEditor){
                this.caller.textAreaEditor.setData('');
            }
        }

        this.getTemplateViewModel().isAddPinnedCustomPageVisible(show);
    }

    public onClickAddPinnedCustomPageItem() {
        const vm = this.getTemplateViewModel();
        const cardEdited = vm.cardEdited();
        const pinnedCustomPageItems = vm.pinnedCustomPageItems().slice();
    
        const cardTitle = vm.customCardTitle();
        const cardLinkoutUrl = vm.customCardLinkoutUrl();
        const cardDescription = this.caller.textAreaEditor.getData();
        const cardImage = this.imageWidget.getImage();
    
        if (cardImage) {
            cardImage.uri = cardImage.url;
            cardImage.src = cardImage.url;
        }
    
        const newItem = {
            cardTitle,
            cardLinkoutUrl,
            cardImage,
            cardDescription
        };
    
        if (cardEdited) {
            const index = pinnedCustomPageItems.findIndex(c =>
                c.cardTitle === cardEdited.cardTitle &&
                c.cardLinkoutUrl === cardEdited.cardLinkoutUrl &&
                c.cardDescription === cardEdited.cardDescription
            );
    
            if (index > -1) {
                pinnedCustomPageItems[index] = newItem;
            } else {
                pinnedCustomPageItems.push(newItem);
            }
    
            vm.cardEdited(null);
        } else {
            pinnedCustomPageItems.push(newItem);
        }
    
        vm.pinnedCustomPageItems([]);
        vm.pinnedCustomPageItems(pinnedCustomPageItems);
    
        this.onClickTogglePinnedCustomPageSection(false);
    }

    public onClickDeletePinnedCustomPageItem(item){

        let pinnedCustomPageItems = this.getTemplateViewModel().pinnedCustomPageItems();
        let index = pinnedCustomPageItems.indexOf(item);
        pinnedCustomPageItems.splice(index, 1);
        this.getTemplateViewModel().pinnedCustomPageItems([]);
        this.getTemplateViewModel().pinnedCustomPageItems(pinnedCustomPageItems);
    }

    public handleDragAndDrop(element, currentObservableArray ,childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
    }

    public getPinnedCustomPages(){
        let items = this.getTemplateViewModel().pinnedCustomPageItems();

        let data = {
            title1: this.getTemplateViewModel().customPageTitle1(),
            title2: this.getTemplateViewModel().numberOfPositionLists() == 2 ? this.getTemplateViewModel().customPageTitle2() : '',
            moreLinkoutTitle1: this.getTemplateViewModel().customPageMoreLinkoutTitle1(),
            moreLinkoutTitle2: this.getTemplateViewModel().numberOfPositionLists() == 2  ? this.getTemplateViewModel().customPageMoreLinkoutTitle2() : '',
            moreLinkoutUrl1: this.getTemplateViewModel().customPageMoreLinkoutUrl1(),
            moreLinkoutUrl2: this.getTemplateViewModel().numberOfPositionLists() == 2 ? this.getTemplateViewModel().customPageMoreLinkoutUrl2() : '',
            items: items
        };

        return data;
    }

    public setPinnedCustomPages(data){
        if(data && data.items && data.items.length > 0){
            this.getTemplateViewModel().customPageTitle1(data.title1);
            this.getTemplateViewModel().customPageTitle2(data.title2);
            this.getTemplateViewModel().customPageMoreLinkoutTitle1(data.moreLinkoutTitle1);
            this.getTemplateViewModel().customPageMoreLinkoutTitle2(data.moreLinkoutTitle2);
            this.getTemplateViewModel().customPageMoreLinkoutUrl1(data.moreLinkoutUrl1);
            this.getTemplateViewModel().customPageMoreLinkoutUrl2(data.moreLinkoutUrl2);
            this.getTemplateViewModel().pinnedCustomPageItems(data.items);

            this.getTemplateViewModel().pinnedHubPageType('custom-pages');
            if(data.title2 != '' || data.moreLinkoutTitle2 != '' || data.moreLinkoutUrl2 != '') {
                this.getTemplateViewModel().numberOfPositionLists(2);
            }
        }
    }

    public onClickEditPinnedCustomPageItem(data){
        this.getTemplateViewModel().cardEdited(data);
        this.getTemplateViewModel().customCardTitle(data.cardTitle);
        this.getTemplateViewModel().customCardLinkoutUrl(data.cardLinkoutUrl);
        if(data.cardImage){
            this.imageWidget.setImage(data.cardImage);
        }
        if (this.caller.textAreaEditor){
            this.caller.textAreaEditor.setData(data.cardDescription);
        }
        this.onClickTogglePinnedCustomPageSection(true, false);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/configSidebar_template.ts